// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3TL-Z","topBottomGutter":"Layout_topBottomGutter__BYlMi"};